import { ChangeDetectionStrategy, Component } from '@angular/core';
import { doCentsToDollars } from '@core/util/money';
import { SIGN_IT_COST_IN_CENTS } from '@models/e-signing';
import { CALL_TO_ACTION_TYPES } from 'src/app/ui/note/note.component';

@Component({
	selector: 'app-sign-it-onboarding-modal',
	templateUrl: './sign-it-onboarding-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SignItOnboardingModalComponent {
	integrationCost = doCentsToDollars(SIGN_IT_COST_IN_CENTS);
	disclaimers = [
		'LawLabs, InfoTrack, and DocuSign may collect, store, and process information provided by you and your clients to facilitate electronic signing (e-signing) services.',
		'Your clients will be redirected to the SignIT website, where they must accept the Terms and Conditions before InfoTrack can proceed with the e-signing process.',
		`After your 3 free signing packages, a fee of ${this.integrationCost} per completed package will apply. This fee will be billed by LawLabs along with your other Closer transactions.`,
		'By default, any SignIT fees related to a matter will be automatically added to the Statement of Account for that matter. You can adjust this default behaviour in your Business Settings.',
	];

	CALL_TO_ACTION_TYPE_CLOSE = CALL_TO_ACTION_TYPES.CLOSE;
}
